import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { EditPanel, CollapsiblePanel } from '../../elements';
import { SurveyEditSurveyComments } from './SurveyEditSurveyComments';

export function SurveyEditSurveyCommentsSection(props: { surveyId: string }) {
    const translate = useTranslate();

    return (
        <EditPanel bottomMargin={true} noPadding={true}>
            <CollapsiblePanel heading={{ dark: true, text: translate('workflow.comments'), initialIsClosed: true }}>
                <SurveyEditSurveyComments surveyId={props.surveyId} />
            </CollapsiblePanel>
        </EditPanel>
    );
}
